import { selectors, useSelector } from '@sloyd/store-base';
import { LoaderBar } from '@sloyd/ui';

export type LoaderBarProps = {};

export function LoaderBarContainer(_props: LoaderBarProps) {
  const isLoading = useSelector(selectors.base.$showLoaderBar);
  const appState = useSelector(selectors.raw.$rawAppState);
  const { editMode } = appState;

  const color = editMode === 'object' ? 'pink' : 'purple';

  return <LoaderBar color={color} isLoading={isLoading} />;
}

export default LoaderBarContainer;
